import { Route, Switch } from 'react-router-dom';
import React from 'react';
import RequestAvailabilityRoutes from './RequestAvailabilityRoutes';
import SuperdayRARoutes from './SuperdayAppRoutes';

const AppRoutes: React.FC = () => {
    return (
        <Switch>
            <Route path="/i" component={SuperdayRARoutes} />
            <Route path="/s" component={SuperdayRARoutes} />
            <Route path="*" component={RequestAvailabilityRoutes} />
        </Switch>
    );
};

export default AppRoutes;
